export default __webpack_public_path__ + "static/media/ic-price.42092797.svg";